module.exports = __webpack_public_path__ + "static/media/icon-auth0.1d06ad06.svg";